/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2025, Zumper
 */

export const CLEAR_SIGN_IN = '@@wsp/account/signIn/CLEAR'
export const CLEAR_SIGN_IN_FIELD_ERROR =
  '@@wsp/account/signIn/CLEAR_FIELD_ERROR'
export const SET_SIGN_IN_ERROR = '@@wsp/account/signIn/SET_SIGN_IN_ERROR'
